import { useMemo } from 'react';

import {
    CampaignTableModerationStatus,
    getCampaignTableModerationStatus,
    getIsActiveStatus,
} from 'components/CampaignsDashboard/utils/utils';

import { DashboardCampaign } from 'store/models/campaignsDashboard';
import { useSelector } from 'store/utils';

export const useCampaignSwitchChecked = (campaign: DashboardCampaign, isLoading = false): boolean => {
    const isArchiveCampaignAlertVisible = useSelector(
        (state) => state.campaignsDashboard.isArchiveCampaignAlertVisible
    );

    const { frontendStatus, banners, productType } = campaign;
    const isActiveStatus = getIsActiveStatus(frontendStatus);
    const moderationTableStatus = getCampaignTableModerationStatus(banners, productType, frontendStatus);

    return useMemo(() => {
        if (moderationTableStatus === CampaignTableModerationStatus.Rejected) {
            return false;
        }
        if (isLoading && !isArchiveCampaignAlertVisible) {
            return !isActiveStatus;
        }
        return isActiveStatus;
    }, [moderationTableStatus, isLoading, isArchiveCampaignAlertVisible, isActiveStatus]);
};
